/* eslint-disable no-throw-literal */
import {
  GET_SUPPLIER_LIST,
  GET_SUPPLIER,
  CREATE_MASTER_SUPPLIER,
  UPDATE_MASTER_SUPPLIER,
  DELETE_SUPPLIER,
  STOCK_OUTPUT_PDF
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_SUPPLIER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/suppliers', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CREATE_MASTER_SUPPLIER] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: '/master/suppliers', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_SUPPLIER] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: `/master/suppliers/${params.id}/edit` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_SUPPLIER] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: `/master/suppliers/${params.id}` })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_MASTER_SUPPLIER] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/suppliers/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STOCK_OUTPUT_PDF] ({ dispatch }, params) {
      const res = await dispatch('apiBlobDownload', { url: `/master/suppliers/pdf_download`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/supplier.js